import { ICellRendererParams } from 'ag-grid-community'
import { Button, styled } from '@mui/material'
import { StatusComboBox } from '../../../components/comboBox/StatusComboBox'
import { intl } from '../../../../i18n'
import { SubStatusRow } from '../SubStatusRow'

const PlaceholderButton = styled(Button)({
  minWidth: '77px',
  height: '22px',
  fontSize: '12px',
  textTransform: 'none',
})

// クリックで即座にセル編集(LinkedStatusCellEditor)を開始し、プルダウンで選べるようにする。
export const LinkedStatusCellRenderer = (
  params: ICellRendererParams<SubStatusRow>
) => {
  const { value, api, node, colDef } = params

  const startEditing = () => {
    api.startEditingCell({
      rowIndex: node.rowIndex ?? 0,
      colKey: colDef?.colId ?? colDef?.field ?? '',
    })
  }

  if (!value) {
    return (
      <PlaceholderButton size="small" onClick={startEditing}>
        {intl.formatMessage({ id: 'subStatus.selectStatus' })}
      </PlaceholderButton>
    )
  }

  return (
    <StatusComboBox
      value={value}
      options={[]}
      dropDownListOpen={false}
      onClick={startEditing}
    />
  )
}
